import { render } from "./buscaPersona.vue?vue&type=template&id=49708824&scoped=true"
import script from "./buscaPersona.vue?vue&type=script&lang=js"
export * from "./buscaPersona.vue?vue&type=script&lang=js"

import "./buscaPersona.vue?vue&type=style&index=0&id=49708824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49708824"]])

export default __exports__